import { _isGreaterOrEqual, _isLessOrEqual } from '@/helpers/bigNumber'
const MAX = 99999999
const MIN = -99999999

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return _isGreaterOrEqual(value, MIN) && _isLessOrEqual(value, MAX)
  }
}
